import React from "react";
import basePath from "../utils/basePath";

class FamilyPhoto extends React.Component {
  state = {};
  componentDidMount = () => {
    this.updateCanvas();
  };
  updateCanvas = () => {
    //Percentage of the total canvas width occupied by avatars e.g. 0.8 = 80%
    let avatarAreaWidthPerc = 1,
      //Width of the overlap between avatars as a percentage of the space dedicated to each avatar. increase this number to make avatars tighter.
      // e.g.  total space = 400px, number of avatars = 4,  space per avatar = 100px, overlapWidthPerc of 0.4 = 40px of overlap between avatars.
      overlapWidthPerc = 1,
      // if images are naturally 150 high and 100 wide this should be set to 1.5 etc.
      avatarHeightRatio = 0.8;

    let canvas = this.refs.canvas,
      ctx = canvas.getContext("2d"),
      avatarAreaWidth = canvas.width * avatarAreaWidthPerc,
      offsetLayout = (canvas.width - avatarAreaWidth) / 2,
      totalMembers = this.props.globalState.family.length,
      //baseWidth = Math.round(avatarAreaWidth / Math.max(3, totalMembers)),
      baseWidth = Math.round(avatarAreaWidth / totalMembers),
      offsetSmallFamily = Math.max(0, ((3 - totalMembers) / 2) * baseWidth),
      overlapWidth = baseWidth * overlapWidthPerc,
      avatarWidth = baseWidth + overlapWidth,
      avatarHeight = avatarWidth * avatarHeightRatio,
      avatarBaseline = canvas.height - avatarHeight - 180,
      categories = ["outfit", "gear", "accessories"],
      familyName = this.props.globalState.familyname,
      imagesLoaded = 0,
      imagesDrawn = false;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    document.fonts.ready.then(function () {
      ctx.font = "30px Aldine";
      ctx.textAlign = "center";
      ctx.fillStyle = "#1c1c1c";
      //ctx.fillText(familyName, canvas.width / 2, canvas.height - 70);
      ctx.font = "normal normal bold 16px Proxima Nova";
      ctx.textAlign = "left";
      ctx.fillStyle = "#b84c16";
      //ctx.fillText("Caption text", 30, canvas.height - 16);
    });
    ctx.fillStyle = "#f4f4f4";
    // ctx.fillRect(30, 30, canvas.width - 60, canvas.width - 60);
    console.log(totalMembers, baseWidth);
    this.props.globalState.family.map((member, index) => {
      categories.map((category) => {
        this.refs[`member${index}${category}`].addEventListener("load", (e) => {
          imagesLoaded++;
          drawImages();
        });
        return null;
      });
      return null;
    });
    this.refs[`family-background`].addEventListener("load", (e) => {
      imagesLoaded++;
      drawImages();
    });
    this.refs[`polaroid-frame`].addEventListener("load", (e) => {
      imagesLoaded++;
      drawImages();
    });
    let drawImages = () => {
      if (imagesLoaded >= totalMembers * categories.length + 2 && !imagesDrawn) {
        imagesDrawn = true;
        ctx.drawImage(this.refs[`polaroid-frame`], 0, 0, 750, 750);
        ctx.drawImage(this.refs[`family-background`], 0, 80, 750, 600);
        this.props.globalState.family.map((member, index) => {
          categories.map((category) => {
            ctx.drawImage(this.refs[`member${index}${category}`], 0, 80, 750, 600);
            // // Transparent box to accurately see bounds of each avatar, for the purpose of positioning
            // ctx.fillStyle = "rgba(255,0,0,0.1)";
            // ctx.fillRect(
            //   index * baseWidth - overlapWidth / 2 + offsetLayout + offsetSmallFamily,
            //   avatarBaseline,
            //   avatarWidth,
            //   avatarHeight
            // );
            return null;
          });
        });
      }
      return null;
    };
  };

  imageRefs = () => {
    let family = this.props.globalState.family,
      categories = ["accessories", "gear", "outfit"];
    let refimages = family.map((member, index) => {
      let partImages = categories.map((category) => {
        return (
          <img
            src={`${basePath}images/parts/${member[category].file}`}
            ref={`member${index}${category}`}
            key={`member${index}${category}`}
            className={`member${index}${category}`}
            alt=""
          />
        );
      });
      return (
        <div key={`member${index}`} className={`member${index}`}>
          {partImages}
        </div>
      );
    });
    return (
      <>
        <img src={`${basePath}images/export-frame.svg`} ref="polaroid-frame" className="frame" alt="" />
        <img src={`${basePath}images/parts/${this.props.backgroundImage}`} ref="family-background" className="family-background" alt="" />
        {refimages}
      </>
    );
  };

  render() {
    return (
      <div className="family-photo">
        <div className="canvas-wrap" ref="canvaswrap">
          <div className="photo-frame">
            <canvas ref="canvas" width="750" height="750"></canvas>
          </div>
          <div className="image-refs">{this.imageRefs()}</div>
        </div>
      </div>
    );
  }
}
export default FamilyPhoto;
